'use strict';
var SupportController = /** @class */ (function () {
    /*@ngInject*/
    function SupportController($scope, seoMetaService) {
        this.showPayIcon = true;
        this.$scope = $scope;
        this.seoMetaService = seoMetaService;
        this.seoMetaService.updateSeoMetaData(this, 'SupportController');
    }
    SupportController.prototype.videoPlayPause = function (event) {
        var videoElement = document.getElementById('support-video');
        if (videoElement.paused) {
            this.showPayIcon = false;
            videoElement.play();
        }
        else {
            this.showPayIcon = true;
            videoElement.pause();
        }
    };
    return SupportController;
}());
export default SupportController;
//# sourceMappingURL=support.controller.js.map